import { render, staticRenderFns } from "./TheUserDrawer.vue?vue&type=template&id=bdba74a0&"
import script from "./TheUserDrawer.vue?vue&type=script&lang=js&"
export * from "./TheUserDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TheUserDrawer.vue"
export default component.exports